import { __extends, __assign } from 'tslib';
import React__default, { createRef } from 'react';
import clsx from 'clsx';
import { propTypes, defaultProps } from './LeftNavSettings.types.js';
import Divider from '../Divider/Divider.component.js';
import Avatar from '../Avatar/Avatar.component.js';
import styles from './LeftNavSettings.module.scss.js';

var LeftNavSettings = /** @class */ (function (_super) {
    __extends(LeftNavSettings, _super);
    function LeftNavSettings() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.node = createRef();
        /**
         * When a mouse is clicked we want to do this:
         * - when we click on the menu we want it to behave normally
         * - when we click outside the menu we want to close it
         *
         * @param {Event} event - a DOM mouse down event
         */
        _this.handleMouseClick = function (event) {
            var _a;
            var closeSettingsMenu = _this.props.closeSettingsMenu;
            // document.activeElement can't be used here since on Safari trigger element would have to be an input
            // menu is already open and the click is *outside*
            if (!((_a = _this.node.current) === null || _a === void 0 ? void 0 : _a.contains(event.target))) {
                closeSettingsMenu();
            }
        };
        _this.handleClick = function (event, link) {
            var onSelectLink = _this.props.onSelectLink;
            event.preventDefault();
            onSelectLink(link);
        };
        return _this;
    }
    LeftNavSettings.prototype.componentDidMount = function () {
        // add an event listener to this component to determine if/when a click
        // happens *outside* of the component
        if (this.props.isOpen) {
            document.addEventListener('click', this.handleMouseClick, true);
        }
    };
    LeftNavSettings.prototype.componentWillUnmount = function () {
        // cleanup
        document.removeEventListener('click', this.handleMouseClick, true);
    };
    LeftNavSettings.prototype.componentDidUpdate = function (prevProps) {
        var didClose = prevProps.isOpen && !this.props.isOpen;
        var didOpen = !prevProps.isOpen && this.props.isOpen;
        if (didOpen) {
            document.addEventListener('click', this.handleMouseClick, true);
        }
        if (didClose) {
            document.removeEventListener('click', this.handleMouseClick, true);
        }
    };
    LeftNavSettings.prototype.render = function () {
        var _this = this;
        var _a = this.props, isOpen = _a.isOpen, settingsLinks = _a.settingsLinks, className = _a.className, userName = _a.userName, userAddress = _a.userAddress, userInfo = _a.userInfo, photoUrl = _a.photoUrl, userNameInitials = _a.userNameInitials, avatarColor = _a.avatarColor;
        return (React__default.createElement(React__default.Fragment, null,
            React__default.createElement("div", { className: isOpen ? styles.Overlay : '' }),
            React__default.createElement("div", { ref: this.node, className: clsx(styles.LeftNavSettings, isOpen && styles.LeftNavSettings___active, className) },
                React__default.createElement("div", { className: styles.LeftNavSettings_header },
                    React__default.createElement("div", { className: styles.SettingsHeader },
                        React__default.createElement(Avatar, { initials: userNameInitials, photoUrl: photoUrl, avatarColor: avatarColor }),
                        React__default.createElement("div", { className: styles.SettingsHeader_name }, userName),
                        React__default.createElement("div", { className: styles.SettingsHeader_address }, userInfo || userAddress))),
                React__default.createElement("ul", { className: styles.LeftNavSettings_content }, settingsLinks.map(function (link) { return (React__default.createElement(React__default.Fragment, { key: link.id },
                    React__default.createElement("li", { className: styles.LeftNavSettings_contentElement },
                        React__default.createElement("button", { className: styles.NavLink, onClick: function (event) {
                                return _this.handleClick(event, link);
                            } }, link.displayName)),
                    link.hasDivider && (React__default.createElement(Divider, { className: styles.Divider })))); })))));
    };
    LeftNavSettings.displayName = 'LeftNavSettings';
    LeftNavSettings.propTypes = propTypes;
    LeftNavSettings.defaultProps = __assign({}, defaultProps);
    return LeftNavSettings;
}(React__default.Component));

export { LeftNavSettings as default };
